module.exports = __webpack_public_path__ + "img/thumbnail_Reindeer_j_normal.acd85b35.png";